import { render, staticRenderFns } from "./PatientDiagnosticPhoto.vue?vue&type=template&id=3e7506b7&scoped=true"
import script from "./PatientDiagnosticPhoto.vue?vue&type=script&lang=js"
export * from "./PatientDiagnosticPhoto.vue?vue&type=script&lang=js"
import style0 from "./PatientDiagnosticPhoto.vue?vue&type=style&index=0&id=3e7506b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7506b7",
  null
  
)

export default component.exports